<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <form-admin-organisation type="this.$route.params.id" v-bind="$attrs"></form-admin-organisation>
        </b-card>
    </div>
</template>

<script>
    import FormAdminOrganisation from '~/components/forms/admin/organisation/form'

    export default {
        name: 'create',
        props: ['type'],
        components: {
            'form-admin-organisation': FormAdminOrganisation,
        },
    }
</script>

<style lang="css" scoped>
</style>